import useUrlQuery from 'Hooks/useUrlQuery';
import { setSignUpFromAmazon } from 'Utils/integration/amazon';
import { useMemo } from 'react';

export function useUniversalSignUpPayload() {
  const params = useUrlQuery();
  const source = params?.src || 'GEN';
  const mode = params?.mode || '';
  const isPathRegister = window.location.pathname.search('registro') > 0;

  const payload = useMemo(() => {
    if (!isPathRegister) return null;

    if (mode.toUpperCase() === 'APP' && source.toUpperCase() === 'AMZ') {
      setSignUpFromAmazon();
      return {
        'ext-signup': 'true',
        login_hint: '',
        screen_hint: 'signup',
      };
    }
    return {
      login_hint: '',
      screen_hint: 'signup',
    };
  }, [isPathRegister, source, mode]);

  return payload;
}
